import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PurchaseHistoryFacade } from './+state';
import { PurchaseHistoryStateModule } from './+state/purchase-history.state.module';
import { PurchaseHistoryService } from './services/purchase-history.service';

@NgModule({
  imports: [CommonModule, PurchaseHistoryStateModule],
})
export class DomainPurchaseHistoryModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainPurchaseHistoryModule,
      providers: [PurchaseHistoryService, PurchaseHistoryFacade],
    };
  }
}
